import styled from 'styled-components'

export const MainContainer = styled.div`
  .result-list-container {
    .localisation-box {
      margin-top: 30px;
    }

    // contains sidebar and results
    .result-container {
      min-height: 500px;
      padding-top: 0;

      .result-container-padding {
        padding-top: 30px;
      }

      // contains tile toggle and sorting
      .result-header {
        display: flex;
        justify-content: space-between;

        &.no-toggle {
          justify-content: flex-end;
        }
      }
    }
  }
`
